// extracted by mini-css-extract-plugin
export var errorsContainer = "_rg-1";
export var link = "_rg-0";